import {
  BackgroundSettingsV1,
  CameraSettingsV1,
  CharacterSettingsV1,
  JobFromAPI,
  LabelSettingsV1,
  PlaybackSettingsV1,
} from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

type JobPostPayload = {
  numFrames: number;
  prompt: string;
  sceneSettings: {
    backgroundSettings?: BackgroundSettingsV1;
    cameraSettings?: CameraSettingsV1;
    characterSettings?: CharacterSettingsV1;
    labelSettings?: LabelSettingsV1;
    playbackSettings?: PlaybackSettingsV1;
  };
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postJob(props: JobPostPayload) {
  const response = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    '/jobs',
    {
      method: 'POST',
      body: JSON.stringify(props),
    },
  );

  // Backwards compatibility for chatHistory
  // Scoot is going to start populating the chatHistory
  if (response.data && !response.data.chatHistory) {
    response.data.chatHistory = [
      {
        type: 'USER',
        prompt: props.prompt,
      },
    ];
  }

  return {
    data: transformJob(response.data),
    error: response.error,
  };
}
